"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputSelect = exports.InputSelectContainer = exports.Widget = exports.Title = exports.ButtonStyled = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../styles/widths");

var _palette = require("../../../styles/palette");

var _Button = _interopRequireDefault(require("../../atoms/Button"));

var _InputSelect = _interopRequireDefault(require("../../atoms/Inputs/InputSelect"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var ButtonStyled = (0, _styledComponents["default"])(_Button["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  margin : ", "px 0;\n  padding: 18px;\n  width  : 100%;\n"])), _widths.widths.base * 2);
exports.ButtonStyled = ButtonStyled;
ButtonStyled.displayName = 'ButtonStyled';

var Title = _styledComponents["default"].h3(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 20px;\n  font-weight: ", ";\n  line-height: 1.5;\n  margin     : ", "px 0;\n  text-align : center;\n  width      : 100%;\n"])), function (props) {
  return props.color ? props.color : _palette.palette.secondary;
}, _widths.font.semi, _widths.widths.base * 2);

exports.Title = Title;
Title.displayName = 'Title';

var Widget = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  background     : linear-gradient(to bottom, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.5));\n  border-radius  : ", "px;\n  box-shadow     : 0 2px 9px 0 rgba(0, 0, 0, 0.1);\n  display        : flex;\n  flex-wrap      : wrap;\n  font-weight    : ", ";\n  justify-content: center;\n  padding        : 0 ", "px;\n  width          : ", "px;\n"])), _widths.widths.base, _widths.font.regular, _widths.widths.base * 2, _widths.widths.base * 40);

exports.Widget = Widget;
Widget.displayName = 'Widget';

var InputSelectContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  width        : 100%;\n  padding      : ", ";\n  background   : white;\n  margin-bottom: ", "px;\n  border-radius: ", "px;\n"])), function (props) {
  return "0px ".concat(_widths.widths.base, "px ").concat(props.error ? _widths.widths.base * 2.5 : _widths.widths.base, "px ").concat(_widths.widths.base, "px");
}, _widths.widths.base, _widths.widths.base);

exports.InputSelectContainer = InputSelectContainer;
InputSelectContainer.displayName = 'InputSelectContainer';
var InputSelect = (0, _styledComponents["default"])(_InputSelect["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-bottom: 0;\n  margin-top   : 0;\n"])));
exports.InputSelect = InputSelect;
InputSelect.displayName = 'InputSelect';